import React from 'react';
import classNames from "classnames";

const DocumentTypeaheadResults = ({
    itemNumbers,
    onTypeaheadResultClick,
    selectedIndex
}) => {
    return (
        <div className="document-typeahead-results">
            <div className="row">
                <div className="col-12 col-lg-12">
                    {itemNumbers.length > 0 &&
                        <div
                            className="typeahead-results-list"
                        >
                            {itemNumbers.map((item, key) => {
                                return (
                                    <div className={`document-typeahead-result-wrapper ${selectedIndex === key ? "selected" : ""}`} key={key} onClick={() => onTypeaheadResultClick(item)}>{item}</div>
                                )
                            })}
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}


export default DocumentTypeaheadResults;